var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.45312 6.84375H3.92773C3.89258 6.53906 3.86328 6.20508 3.9043 5.90039H3.51758C2.07617 5.90039 1.05078 4.88672 1.05078 3.43359C1.05078 1.99219 2.08203 0.972656 3.51758 0.972656H8.71484C10.1504 0.972656 11.1816 1.99219 11.1816 3.43359C11.1816 4.88672 10.1504 5.90039 8.71484 5.90039H6.6582C6.57617 6.12891 6.60547 6.57422 6.78711 6.84375H8.7793C10.7656 6.84375 12.1836 5.44922 12.1836 3.43359C12.1836 1.42383 10.7656 0.0292969 8.7793 0.0292969H3.45312C1.4668 0.0292969 0.0488281 1.42383 0.0488281 3.43359C0.0488281 5.44922 1.4668 6.84375 3.45312 6.84375ZM8.15234 9.56836H13.4785C15.4648 9.56836 16.8828 8.17383 16.8828 6.1582C16.8828 4.14844 15.4648 2.75391 13.4785 2.75391H12.998C13.0332 3.05273 13.0625 3.39258 13.0273 3.69727H13.4082C14.8496 3.69727 15.8809 4.71094 15.8809 6.1582C15.8809 7.60547 14.8496 8.625 13.4082 8.625H8.2168C6.78125 8.625 5.75 7.60547 5.75 6.1582C5.75 4.71094 6.77539 3.69727 8.2168 3.69727H10.2734C10.3555 3.46875 10.3262 3.02344 10.1387 2.75391H8.15234C6.16016 2.75391 4.74805 4.14844 4.74805 6.1582C4.74805 8.17383 6.16016 9.56836 8.15234 9.56836Z",
    fill: "#3779E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.2bbc9098a2bb9e3f65c5e718d1ba394d.svg";
export { ForwardRef as ReactComponent };